<template>
  <div class="component-theme-switcher">
    <svg
      v-if="currentTheme === 'dark'"
      class="svgfont hover:!bm-text-effect"
      :class="[{ dark: currentTheme === 'light' }]"
      @click="onSwitch"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      viewBox="0 0 512 512"
    >
      <path
        d="M209.986 60.559c-8.464 36.133-9.615 73.595-3.387 110.179s19.709 71.555 39.653 102.853c19.943 31.299 45.944 58.29 76.472 79.392 30.531 21.102 64.971 35.882 101.299 43.476-19.101 19.757-41.976 35.478-67.266 46.227s-52.484 16.308-79.965 16.344c-2.556 0-5.136 0.096-7.713 0-47.84-1.692-93.576-20.088-129.265-51.994-35.689-31.902-59.074-75.3-66.097-122.652s2.763-95.669 27.657-136.557 63.322-71.766 108.613-87.269zM237.262 16c-1.081 0.002-2.159 0.098-3.224 0.288-58.786 10.442-111.629 42.267-148.352 89.344s-54.726 106.079-50.544 165.637c4.182 59.558 30.256 115.467 73.197 156.948 42.941 41.483 99.714 65.61 159.382 67.733 3.030 0.111 6.060 0 9.063 0 38.748 0.021 76.929-9.291 111.321-27.141 34.389-17.853 63.975-43.725 86.253-75.426 1.809-2.73 2.861-5.889 3.057-9.159 0.198-3.27-0.471-6.531-1.938-9.459-1.464-2.931-3.678-5.421-6.414-7.221-2.733-1.803-5.895-2.85-9.165-3.042-36.882-3.234-72.529-14.907-104.178-34.116-31.653-19.209-58.464-45.438-78.36-76.661-19.899-31.224-32.35-66.605-36.392-103.407s0.432-74.043 13.077-108.841c1.076-2.785 1.47-5.785 1.153-8.752s-1.341-5.816-2.983-8.309c-1.643-2.492-3.856-4.556-6.457-6.020s-5.515-2.285-8.498-2.396v0z"
      ></path>
    </svg>
    <svg
      v-if="currentTheme === 'light'"
      class="svgfont hover:!bm-text-effect"
      :class="[{ dark: currentTheme === 'dark' }]"
      @click="onSwitch"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      viewBox="0 0 512 512"
    >
      <path
        d="M237.716 0h36.572v90.696h-36.572v-90.696zM359.993 125.988l64.126-64.108 25.858 25.856-64.128 64.128-25.855-25.876zM421.304 237.716h90.696v36.572h-90.696v-36.572zM360.097 385.9l25.858-25.855 64.128 64.126-25.858 25.842-64.128-64.11zM237.716 421.304h36.572v90.696h-36.572v-90.696zM62.1 424.265l64.148-64.129 25.856 25.855-64.128 64.129-25.876-25.855zM0 237.716h90.696v36.572h-90.696v-36.572zM61.99 87.828l25.876-25.856 64.128 64.128-25.856 25.856-64.148-64.128zM256 182.856c40.394 0 73.144 32.746 73.144 73.144s-32.746 73.144-73.144 73.144c-40.394 0-73.144-32.746-73.144-73.144s32.746-73.144 73.144-73.144zM256 146.284c-60.596 0-109.716 49.12-109.716 109.716s49.12 109.716 109.716 109.716c60.596 0 109.716-49.12 109.716-109.716s-49.12-109.716-109.716-109.716z"
      ></path>
    </svg>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import commonMixins from '../mixins'
import { NAVIGATOR_BAR_CONFIG_MAP, NAVIGATOR_BAR_CONFIG_DEFAULT } from '../config'

import { usePatchStore } from '~/common/js/patch';
export default {
  name: 'ComponentThemeswitcher',
  components: {},

  mixins: [commonMixins],

  data() {
    return {
      cookieTheme: Cookies.get('isDayMode') ? (Cookies.get('isDayMode') === 'true' ? 'light' : 'dark') : null,
    };
  },
  computed: {
    isDayMode() {
      return this.store.isDayMode;
    },
    globalTheme() {
      return this.store.globalTheme;
    },
    theme() {
      return this.$route?.query?.theme;
    },
    navigatorBarConfig() {
      return {
        ...NAVIGATOR_BAR_CONFIG_DEFAULT,
        ...(NAVIGATOR_BAR_CONFIG_MAP.get(this.$route.name) || {}),
      }
    },
    currentTheme() {
      // 如果是在非trade页，则根据globalTheme的值来
      if (['trade-lang', 'trade-lang-margin'].indexOf(this.$route.name) >= 0) {
        return this.isDayMode ? 'light' : 'dark'
      } else {
        return this.globalTheme
      }
    },
  },

  methods: {
    // 非trade页的主题**设置**逻辑
    // 皮肤主题切换优先级策略（针对非trade页，trade页的主题色管理自治管理，因此使用额外一套皮肤管理机制）

    // 0. 当路由发生切换时，都会重新检查当前页面是否启用了主题色切换，通过themeSwitcher
    // 1. 先判断当前页面是否启用了主题色切换功能，如果未启用，则主题不生效，使用它的默认主题色（不一定是浅色）
    // 2. 若已启用，则先依次取出原有值
    //    1. 检查url query中是否存在global_theme
    //    2. 如果没有，再检查cookie中是否存在GLOBAL_THEME字段
    //    3. 如果没有，再检查localStore中是否存在GLOBAL_THEME字段
    // 将最终的主题颜色，存储到cookie/localStore/vuex store中各一份

    initTheme() {
      // 判断一下当前的路由是不是trade页
      if (['trade-lang', 'trade-lang-margin'].indexOf(this.$route.name) >= 0) {
        this.initTradeTheme()
      } else {
        this.initGlobalTheme()
      }
    },
    // 全局主题切换
    // 同时，也暴露给外部使用，每次路由切换都支持调用，变更各地方设置的值
    initGlobalTheme() {
      // 如果当前主题切换未启用
      if (!this.navigatorBarConfig?.themeSwitcher) {
        this.store.commit('SET_GLOBAL_THEME_SWITCHER', false)
        // 不用走后面的逻辑
        return
      } else {
        this.store.commit('SET_GLOBAL_THEME_SWITCHER', true)
      }

      let theme = this.$route?.query?.global_theme
      const existTheme = theme && ['undefined', 'null'].indexOf(theme) === -1
      const cookieTheme = Cookies.get('GLOBAL_THEME') || null
      const lsTheme = window?.localStorage?.getItem('GLOBAL_THEME') || null
      if (!existTheme) {
        if (cookieTheme) theme = cookieTheme
        else if (lsTheme) theme = lsTheme
      }

      // 求得最终的主题色
      theme = theme || 'light'

      // 设置主题
      this.setTheme('GLOBAL_THEME', theme)
    },
    // 设置vuex store
    // 设置cookie
    // 设置localStorage
    setTheme(type, theme) {
      // @todo trade未改造
      this.store.commit(type === 'GLOBAL_THEME' ? 'SET_GLOBAL_THEME' : 'SET_GLOBAL_THEME', theme)

      // 再设置一次
      Cookies.set(type, theme, {
        httpOnly: false,
        secure: import.meta.env.VITE_DEBUG === 'true' ? false : true,
        sameSite: 'Lax',
      })

      window.localStorage.setItem(type, theme)
    },
    initTradeTheme() {
      // 根据优先级，将theme写到3个存储区域
      // 塞入cookie的时间，提前到create里了
      let theme = this.theme;

      const existTheme = this.theme && ['undefined', 'null'].indexOf(this.theme) === -1;

      // 以url query中的样式为最高优先级中的为准
      if (!existTheme) {
        // 先取cookie里面的
        if (this.cookieTheme) theme = this.cookieTheme;
        else if (window.localStorage.getItem('isDayMode') === 'true') theme = 'light';
        else theme = 'dark';
      }

      const isDayMode = theme === 'light';

      this.commit('SET_ISDAYMODE', isDayMode);

      // 再设置一次
      Cookies.set('isDayMode', isDayMode, {
        httpOnly: false,
        secure: import.meta.env.VITE_DEBUG === 'true' ? false : true,
        sameSite: 'Lax',
      });

      window.localStorage.setItem('isDayMode', isDayMode);
    },
    // 主题色的切换逻辑
    // 将最终的主题颜色，存储到cookie/localStore/vuex store中各一份
    onSwitch() {
      // 判断一下当前的路由是不是trade页
      if (['trade-lang', 'trade-lang-margin'].indexOf(this.$route.name) >= 0) {
        this.onTradeSwitch()
      } else {
        this.onGlobalSwitch()
      }
    },
    onTradeSwitch() {
      const isDayMode = !this.isDayMode

      this.commit('SET_ISDAYMODE', isDayMode);
      window.localStorage.setItem('isDayMode', isDayMode);

      Cookies.set('isDayMode', isDayMode, {
        httpOnly: false,
        secure: import.meta.env.VITE_DEBUG === 'true' ? false : true,
        sameSite: 'Lax',
      });

      // 导航头主题按钮切换事件里加了一个逻辑，让class主题类名附加更迅速，解决浅暗色皮肤变化有延迟现象
      const currentTheme = !isDayMode ? 'day-mode' : 'night-mode';
      const targetTheme = isDayMode ? 'day-mode' : 'night-mode';
      const htmlClass = document.documentElement.getAttribute('class') || '';
      document.documentElement.setAttribute('class', `${htmlClass.replace(currentTheme, '')} ${targetTheme}`);

      window.bus && window.bus.$emit('kchartThemeRender', isDayMode);

      this.$router.replace({
        query: {
          ...this.$route.query,
          theme: isDayMode ? 'light' : 'dark',
        },
      });
    },
    onGlobalSwitch() {
      const theme = this.globalTheme === 'light' ? 'dark' : 'light'
      this.setTheme('GLOBAL_THEME', theme)
      this.$router.replace({
        query: {
          ...this.$route.query,
          global_theme: theme,
        },
      })
    },
  },

  beforeCreate() {
    const unexistTheme = !this.theme || ['undefined', 'null'].indexOf(this.theme) >= 0;

    if (!unexistTheme) {
      Cookies.set('isDayMode', this.theme === 'light', {
        httpOnly: false,
        secure: import.meta.env.VITE_DEBUG === 'true' ? false : true,
        sameSite: 'Lax',
      });
    }
  },

  async mounted() {
    this.initTheme();
  },
  watch: {
    '$route.name'() {
      this.initTheme()
    },
  },
  setup() {
    const { store, commit } = usePatchStore();
    return {
      store,
      commit
    };
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/ui.variables.less';

.component-theme-switcher {
  .svgfont {
    &.light {
      color: @white_color;
    }
    &.dark {
      color: @black_color;
    }
  }
}
</style>
